/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Fail_KeysInputs */

const en_import_fail_keys = /** @type {(inputs: Import_Fail_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI or Supadata key is missing or wrong (Settings → AI)`)
};

const de_import_fail_keys = /** @type {(inputs: Import_Fail_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI- oder Supadata-Schlüssel fehlt oder ist falsch (Optionen → KI)`)
};

/**
* | output |
* | --- |
* | "The AI or Supadata key is missing or wrong (Settings → AI)" |
*
* @param {Import_Fail_KeysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_fail_keys = /** @type {((inputs?: Import_Fail_KeysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Fail_KeysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_fail_keys(inputs)
	return en_import_fail_keys(inputs)
});